import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Login } from '../actions/actions';

import { useCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { LEFTRIGHT_PADDING } from "../config/style.config";
import { postUploadSigatrue } from "../services/document-s3.service";
import { COOKIESPREFIX, isNewPermitSystemWithSigniture } from "../config";
//svg
import TitleLeftSvg from '../svgs/TitleLeftSvg'
import WhiteCloseSvg from '../svgs/WhiteCloseSvg'

const POP_SCREEN = {
    signature: 'signature'
}

function Screen(props){
    const [cookies, setCookie, removeCookie] = useCookies([`@${COOKIESPREFIX}_cred`,`@${COOKIESPREFIX}_token`]);
    
    const navigate = useNavigate();
    const [popScreen, setPopScreen] = useState(null)

    const uploadImage = async (e, signatureIndex) => {
        const _id = props.control.userData._id
        const file = e.target.files[0];
        if (!['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) { alert(`文件類型不允許: ${file.type}`); return }
        if (file.size > 1024 * 1024 * 2) { alert(`檔案大小必須在 2 MB 以內`); return }
        let formData = new FormData();
        formData.append('file', file, file.name);
        formData.append('json', JSON.stringify({}));
        const res = await postUploadSigatrue(`signature/${_id}`, signatureIndex, formData, props.token.token)
        if(res.errno) return alert('Error uploading')
        logOut()
    }
    function logOut(){
        alert('Login Again.')
        removeCookie(`@${COOKIESPREFIX}_cred`,{path:'/'});
        removeCookie(`@${COOKIESPREFIX}_token`,{path:'/'});
        props.dispatch(Login(false))
        navigate('/')
    }



    return(
        <div className="flex-col bg-[#0C0D14] flex-1 text-[14px] h-full pb-12" style={{overflowY:'auto'}}>

            <div className=''style={{...LEFTRIGHT_PADDING}}>
                <div className="flex flex-row mt-[40px]">
                    <TitleLeftSvg className='mr-[9px]'/>
                    <div className="text-[24px] text-white font-bold ">User Setting</div>
                </div>
                <div className="w-full flex flex-col mt-4">
                    {isNewPermitSystemWithSigniture && <div className="w-full flex flex-row items-center justify-start">
                        <TitleLeftSvg className='mr-[9px] scale-[0.8]'/>
                        <div className="text-white flex flex-row items-end justify-start text-[1.3rem]">E-Signature</div>
                        <div className="button_blue flex" onClick={() => setPopScreen(POP_SCREEN.signature)}>Manage e-signature</div>
                    </div>}
                </div>
            </div>
            {popScreen === POP_SCREEN.signature && <div className='select-none w-[100vw] h-[100vh] fixed inset-0 flex flex-row items-center justify-center backdrop-blur-sm' style={{zIndex:99}}>
                <div className="w-[35%] max-w-[95%] h-[646px] border border-[#FFFFFF80] rounded bg-[#363636B2] p-[40px] text-white flex flex-col" style={{zIndex:99,minWidth:'min( 684px , 100% )'}}>
                    <div className="flex flex-row justify-between mb-8">
                        <div className="text-[18px] font-bold">Manage e-signature</div>
                        <WhiteCloseSvg className='cursor-pointer' onClick={() => {setPopScreen(null)}}/>
                    </div>
                    <div className="w-full">
                        {Array.from({length: 1}).map((_, idx) => <SignatrueRow key={'signature' + idx} idx={idx} uploadImage={uploadImage} url={props.control.userData.data?.signature?.[idx]}/>)}
                    </div>
                </div>
            </div>}
        </div>
    )
}
function SignatrueRow({idx, uploadImage, url = null}){
    return(<div key={'signature' + idx}>
        <div className="w-full flex flex-row items-center justify-between">
            <div className="flex items-center">
                <TitleLeftSvg className='mr-[9px] scale-[0.5]'/>
                <div className="text-white flex flex-row items-end justify-start text-[1rem]">Signature #{idx + 1}</div>
            </div>
            <input accept="image/jpeg,image/png,image/jpg" type="file" onChange={(e) => uploadImage(e, idx)}></input>
        </div>
        {url && <img src={url} className="h-[100px]"></img>}
    </div>)
}

export default connect((store) => {
    return {
      token: store.tokenReducer,
      control: store.controlReducer,
    }
  })(Screen)